'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactHelmet = require('react-helmet');var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
var _reduxPagan = require('redux-pagan');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _SearchBoxContainer = require('../../containers/SearchBoxContainer/SearchBoxContainer');var _SearchBoxContainer2 = _interopRequireDefault(_SearchBoxContainer);
var _MobileBuyRentButtons = require('../../components/MobileBuyRentButtons/MobileBuyRentButtons');var _MobileBuyRentButtons2 = _interopRequireDefault(_MobileBuyRentButtons);
var _mobilesFilters = require('../../redux/modules/mobilesFilters');

var _NotFoundPage = require('./NotFoundPage.scss');var styles = _interopRequireWildcard(_NotFoundPage);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Styles
var
NotFoundPage = function (_React$Component) {_inherits(NotFoundPage, _React$Component);function NotFoundPage() {_classCallCheck(this, NotFoundPage);return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));}NotFoundPage.prototype.
  render = function render() {var _props =
    this.props,translate = _props.translate,locale = _props.locale,isMobile = _props.isMobile,propertyTypes = _props.propertyTypes,openFilters = _props.openFilters;
    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.notFoundWrapper, 'pageHeight') },
        _react2.default.createElement(_reactHelmet2.default, {
          titleTemplate: translate('title', 'titleTemplate')(),
          title: translate('title', 'notFound')() }),

        _react2.default.createElement('div', { className: styles.content },
          !isMobile &&
          _react2.default.createElement('div', { className: styles.formSearch },
            _react2.default.createElement(_SearchBoxContainer2.default, {
              isMobile: isMobile,
              locale: locale,
              translate: translate('search_box'),
              rootTranslate: translate,
              isShown: !isMobile,
              propertyTypes: propertyTypes })),



          _react2.default.createElement('img', { className: styles.icon, src: '/icons/icon-smile.png', alt: 'not found' }),
          isMobile && _react2.default.createElement(_MobileBuyRentButtons2.default, { translate: translate('search_box', 'searchContainer'), openFilters: openFilters }),
          _react2.default.createElement('h1', null, translate('notFound', 'oop'), '!'),
          _react2.default.createElement('p', null, translate('notFound', 'pageNotFound')),
          _react2.default.createElement('p', null,
            translate('notFound', 'goBack'), '\xA0',
            _react2.default.createElement('a', { href: '/', className: 'link' }, translate('notFound', 'toHomePage'))))));




  };return NotFoundPage;}(_react2.default.Component);


NotFoundPage.propTypes = {
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  propertyTypes: _propTypes2.default.object,
  openFilters: _propTypes2.default.func };


var mapDispatchToProps = {
  openFilters: _mobilesFilters.openMobileFilters };


var mapStateToProps = function mapStateToProps(state) {return {
    propertyTypes: state.propertyTypes.sorted || {},
    translate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    locale: state.lang.locale,
    isMobile: state.windowDimentions.isMobile };};exports.default =


(0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(
NotFoundPage);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/NotFoundPage/NotFoundPage.js
// module id = 3068
// module chunks = 0